/**
 * Parses ACF `lesson_learned`: textarea with \r\n-separated bullet lines.
 */
export function getLessonLearnedItems(course) {
    const raw = course?.acf?.lesson_learned;
    let lines = [];

    if (Array.isArray(raw)) {
        lines = raw.map((s) => String(s).trim()).filter(Boolean);
    } else if (typeof raw === "string") {
        lines = raw
            .split(/\r?\n/)
            .map((s) => s.trim())
            .filter(Boolean);
    }

    // كل سطر من الحقل كما هو — بدون دمج التكرارات
    return lines;
}
